import { faFileContract } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { CardHeader, Avatar, Typography } from '@material-ui/core'
import React from 'react'

export interface CardHeaderProps {
  avatarIcon: JSX.Element
  title: string
  titleVariant?: 'primary' | 'secondary'
  action?: React.ReactNode
}

export const Header: React.FC<CardHeaderProps> = ({
  avatarIcon,
  title,
  titleVariant = 'primary',
  action
}) => {
  return (
    <CardHeader
      avatar={<Avatar>{avatarIcon}</Avatar>}
      title={
        <Typography
          variant={titleVariant === 'primary' ? 'h1' : 'h2'}
          color={titleVariant === 'primary' ? 'primary' : 'secondary'}
        >
          {title}
        </Typography>
      }
      action={action}
    ></CardHeader>
  )
}
